<div class="app-content">
  <router-outlet />
</div>
